











































































































import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import { MessageBox } from 'element-ui';
import ReviewDialog from '../moments/review-dialog.vue';
import ImageViewer from '~/components/public/image-viewer.vue';
import { sendComment, deleteSelfComment } from '@/api/index';
import commentTextarea from '@/components/public/comment/comment-textarea.vue';
import { linkPage } from '~/utils/util';
import { formatCommit } from '~/utils';
import MessageDialog from '~/components/public/violation/message-dialog.vue';
import ComplaintDialog from '~/components/public/violation/complaint-dialog.vue';
import { reviewCheckSensitive } from '@/api/moments';
export default {
  name: "PostCommentItem",
  components: {
    MessageDialog,
    ElImageViewer: ImageViewer,
    commentTextarea,
    ReviewDialog,
    ComplaintDialog
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    isChiefGroup: {
      type: Boolean,
      default: false
    },
    isLocalComment: {
      type: Boolean,
      default: false,
    },
    moduleType: {
      type: String,
      default: "community"
    },
    isMoment: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      messageData: {
        show: false,
        content: '',
      },
      linkPage,
      formatCommit,
      previewSrcList: [],
      showViewer: false,
      isShowComment: false,
      dayjs,
      dialogShow: false,
      query: {},
      reviewDialog: {
        content: null,
        refId: null,
        source: 'comment',
        show: false
      },
    }
  },
  computed: {
    ...mapGetters('user', ['loginInfo', 'userId']),
  },
  methods: {
    handleComment() {
      if (this.isShowComment) {
        this.isShowComment = false
      } else if (this.isLocalComment) {
        this.handleCommentBtn()
      }
    },
    handleCommentBtn() {
      if (!this.isShowComment) {
        this.isShowComment = true
        this.$nextTick(() => {
          let refEl = this.$refs[`comment-input-${this.data.commentId}`]
          if (Array.isArray(refEl)) {
            refEl = refEl[0]
          }
          if (refEl) {
            refEl.focusInput()
          }
        })
      } else {
        this.isShowComment = false
      }
    },
    /**
     * @description 审核弹窗
     */
     async handleReview() {
      const query = {
        source: 'comment',
	      refId: this.data.commentId
      }
      const data = await this.$axios(reviewCheckSensitive(query))
      if ([2024, 200].includes(data.statusCode)) {
        let content = null
        if (data.statusCode === 2024) {
          content = data.result
        }
        this.reviewDialog = {
          content,
          refId: this.data.commentId,
          source: 'comment',
          show: true
        }
      } else {
        this.messageData.show = true;
        this.messageData.content = data.message;
      }
    },
    handleReviewClose() {
      this.reviewDialog = {
        content: null,
        refId: null,
        source: 'comment',
        show: false
      }
    },
    handleReviewSuccess() {
      this.messageData.show = true;
      this.messageData.content = '内容审核已通过';
      this.data.reviewStatus = "approved"
    },
    handleReviewError(err) {
      this.messageData.show = true;
      this.messageData.content = err;
    },
    /**
     * @description 发送评论
     */
     async sendCommentHandle(data) {
      const res = await this.$axios(
        sendComment({
          source: "dynamic",
          refId: data.replyId,
          content: data.content,
          pictureUrls: data.pictureUrls,
          replyCommentId: data.replyCommentId,
          retweet: data.retweet,
        })
      );
      this.messageData.title = '温馨提示';
      if (res.statusCode === 200) {
        this.$emit("commentSuccess", res.result)
        this.messageData.content = '已发布<br>内容审核中';
        this.isShowComment = false
      } else if (res.statusCode === 417) {
        this.messageData.content = `当前内容审核中无法${
          data.replyCommentId ? '回复' : '评论'
        }`;
      } else {
        this.messageData.content = res.message;
      }
      this.messageData.show = true;
    },
    handleComplaint() {
      this.query = {
        id: this.data.commentId,
        source: 'comment',
        type: 'content',
        userId: this.data.user.id,
      };
      this.dialogShow = true;
    },
    /**
     * @description 关闭投诉弹窗
     */
    closeComplaint() {
      this.showMore = false;
      this.dialogShow = false;
    },
    /**
     * @description 删除
     */
     handleDelete() {
      MessageBox.confirm('此操作将删除该评论, 是否继续?', '删除动态', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const data = await this.$axios(
          deleteSelfComment({
            commentId: this.data.commentId,
          })
        );
        if (data.statusCode === 200) {
          this.$emit('deleteComment');
        }
      });
    },
  }
}
